// HtmlSVG.jsx
import React from "react";

const HtmlSVG = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>HTML SVG - Scalable Vector Graphics</h1>

      {/* Introduction */}
      <section id="introduction">
        <h2>1. Introduction</h2>
        <p>
          <strong>SVG</strong> (Scalable Vector Graphics) is an XML-based format for creating vector images directly in HTML. Unlike raster images, SVG graphics scale without losing quality.
        </p>
      </section>

      {/* Basic SVG Element */}
      <section id="basic-svg">
        <h2>2. Basic SVG Element</h2>
        <p>Basic syntax:</p>
        <pre>
          <code>{`<svg width="200" height="200" xmlns="http://www.w3.org/2000/svg">
  <!-- SVG shapes go here -->
</svg>`}</code>
        </pre>
        <svg width="200" height="200" style={{ border: "1px solid #ccc" }}>
          <circle cx="100" cy="100" r="50" fill="#007bff" />
        </svg>
      </section>

      {/* Shapes */}
      <section id="shapes">
        <h2>3. Common Shapes</h2>

        {/* Rectangle */}
        <h3>Rectangle</h3>
        <svg width="200" height="100" style={{ border: "1px solid #ccc" }}>
          <rect x="10" y="10" width="150" height="80" fill="#28a745" />
        </svg>

        {/* Circle */}
        <h3>Circle</h3>
        <svg width="200" height="100" style={{ border: "1px solid #ccc" }}>
          <circle cx="100" cy="50" r="40" fill="#ff5733" />
        </svg>

        {/* Ellipse */}
        <h3>Ellipse</h3>
        <svg width="200" height="100" style={{ border: "1px solid #ccc" }}>
          <ellipse cx="100" cy="50" rx="80" ry="40" fill="#ffc107" />
        </svg>

        {/* Line */}
        <h3>Line</h3>
        <svg width="200" height="100" style={{ border: "1px solid #ccc" }}>
          <line x1="10" y1="90" x2="190" y2="10" stroke="#000" strokeWidth="2" />
        </svg>

        {/* Polygon */}
        <h3>Polygon</h3>
        <svg width="200" height="100" style={{ border: "1px solid #ccc" }}>
          <polygon points="50,10 150,10 100,80" fill="#6f42c1" />
        </svg>

        {/* Polyline */}
        <h3>Polyline</h3>
        <svg width="200" height="100" style={{ border: "1px solid #ccc" }}>
          <polyline points="10,80 50,10 100,50 150,10 190,80" stroke="#ff1493" fill="none" strokeWidth="2" />
        </svg>
      </section>

      {/* Text in SVG */}
      <section id="svg-text">
        <h2>4. Text in SVG</h2>
        <svg width="300" height="100" style={{ border: "1px solid #ccc" }}>
          <text x="10" y="50" fontFamily="Arial" fontSize="20" fill="#007bff">
            Hello SVG
          </text>
        </svg>
      </section>

      {/* Colors and Styles */}
      <section id="colors-styles">
        <h2>5. Colors and Styles</h2>
        <p>SVG supports fill, stroke, and opacity styling:</p>
        <svg width="200" height="100" style={{ border: "1px solid #ccc" }}>
          <rect x="10" y="10" width="80" height="80" fill="#28a745" stroke="#000" strokeWidth="3" />
          <circle cx="150" cy="50" r="40" fill="none" stroke="#ff5733" strokeWidth="4" />
        </svg>
      </section>

      {/* Gradients */}
      <section id="gradients">
        <h2>6. Gradients</h2>
        <svg width="200" height="100" style={{ border: "1px solid #ccc" }}>
          <defs>
            <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" style={{ stopColor: "#ff0", stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: "#f00", stopOpacity: 1 }} />
            </linearGradient>
          </defs>
          <rect x="10" y="10" width="180" height="80" fill="url(#grad1)" />
        </svg>
      </section>

      {/* Animations */}
      <section id="animations">
        <h2>7. Animations</h2>
        <p>Simple SVG animation with <code>&lt;animate&gt;</code>:</p>
        <svg width="200" height="100" style={{ border: "1px solid #ccc" }}>
          <circle cx="50" cy="50" r="20" fill="#007bff">
            <animate attributeName="cx" from="50" to="150" dur="2s" repeatCount="indefinite" />
          </circle>
        </svg>
      </section>

      {/* Best Practices */}
      <section id="best-practices">
        <h2>8. Best Practices</h2>
        <ul>
          <li>Use SVG for vector-based graphics to keep them scalable and resolution-independent.</li>
          <li>Always set width and height for proper rendering.</li>
          <li>Group elements with <code>&lt;g&gt;</code> for better control and transformations.</li>
          <li>Optimize SVG for performance (remove unnecessary metadata).</li>
          <li>Use CSS for styling where possible to separate design and content.</li>
        </ul>
      </section>
    </div>
  );
};

export default HtmlSVG;
